import { render, staticRenderFns } from "./tabTruckingUICustom.vue?vue&type=template&id=59583da7&scoped=true&"
import script from "./tabTruckingUICustom.vue?vue&type=script&lang=js&"
export * from "./tabTruckingUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabTruckingUICustom.vue?vue&type=style&index=0&id=59583da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59583da7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59583da7')) {
      api.createRecord('59583da7', component.options)
    } else {
      api.reload('59583da7', component.options)
    }
    module.hot.accept("./tabTruckingUICustom.vue?vue&type=template&id=59583da7&scoped=true&", function () {
      api.rerender('59583da7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabTruckingUICustom.vue"
export default component.exports